import React, { useState, useMemo, useCallback } from "react";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import {
  TextField,
  FormControl,
  Stack,
  InputAdornment,
  IconButton,
  Grid,
  FormHelperText,
  Autocomplete,
  ListItem,
  Tooltip,
} from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import {
  IDatePickerProps,
  IDateRangePickerProp,
  IMonthYearRangePickerProps,
  IQuarterPickerProps,
} from "./DatePickerProps";
import moment from "moment";
import "moment/locale/th";
import { language } from "config/AppConfig";
import {
  DateRangePicker,
  LicenseInfo,
  DatePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers-pro";
import EventIcon from "@mui/icons-material/Event";
import CloseIcon from "@mui/icons-material/Close";
import { I18NextNs, Language } from "enum/enum";
import { I18n, ParseHtml, SecureStorage } from "utilities/utilities";
import secureLocalStorage from "react-secure-storage";
class CustomAdapter extends AdapterMoment {
  constructor({ locale, formats, instance }) {
    super({ locale, formats, instance });
  }

  calYear(moment) {
    switch (this.locale) {
      case "th":
        return (parseInt(moment.format("YYYY")) + 543).toString();
      // return (parseInt(moment.format('YYYY'))).toString();
      case "en":
        return parseInt(moment.format("YYYY"));
      default:
        return parseInt(moment.format("YYYY"));
    }
  }

  renderLabel(moment, format) {
    switch (format) {
      case "year":
        return this.calYear(moment);
      case "month":
        return moment.format("MMMM");
      case "fullDate":
        return moment.format("DDMMYYYY");
      case "dayOfMonth":
        return moment.format("D");
      case "monthShort":
        return moment.format("MMMM");
      case "monthAndYear":
        return `${moment.format("MMMM ")} ${this.calYear(moment)}`;
      case "normalDate":
        return `${moment.format("dd")} ${moment.format("MMM")} ${moment.format(
          "D"
        )}`;
      default:
        return moment.format(format);
    }
  }
  startOfMonth = (date) =>
    date ? date.clone().startOf("month") : moment(new Date());

  format = (date, formatKey) => {
    return date ? this.renderLabel(date, formatKey) : moment(new Date());
  };
}

const localeMap = (language) => {
  switch (language) {
    case "th":
      moment.locale("th");
      break;
    case "en":
      moment.locale("en");
      break;
    default:
      break;
  }
};

export const DateRangePickerItem = (props: IDateRangePickerProp) => {
  LicenseInfo.setLicenseKey(
    "049fdd25559575ef04f65a9e1ed5aabaTz02NDk0MCxFPTE3MTM2NzY2MjYyNzIsUz1wcm8sTE09cGVycGV0dWFsLEtWPTI="
  );

  const {
    name,
    minDate,
    maxDate,
    defaultCalendarMonth = null,
    label = "",
    labelStart = "",
    labelEnd = "",
    required = false,
    calendarsCount = 2,
    disabled = false,
    disablePast = false,
    isShowMessageError = true,
    IsDisablePortal = false,
  } = props;

  let format = props.format ?? "DD/MM/YYYY";

  const formatDefault = format;
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const [locale, setLocale] = useState<string>(language);

  const { control } = useFormContext();

  const ReplaceThFormat = (text) => {
    return text
      ? text
        .toLowerCase()
        .replaceAll("d", "ว")
        .replaceAll("m", "ด")
        .replaceAll("y", "ป")
      : "";
  };

  const maskMap = {
    en: formatDefault,
    th: ReplaceThFormat(formatDefault),
  };

  const [objCheckReplace] = useState(() => {
    localeMap(locale);
    let objReturn = { isReplaceYear: false, indexArr: 0, splitText: "" };
    let formatLower = formatDefault.toLowerCase();
    if (formatLower.includes("yyyy")) {
      let splitText = formatDefault
        .substr(formatLower.indexOf("yyyy") - 1, 1)
        .toLowerCase();
      if (splitText !== "y") {
        objReturn.splitText = splitText;
        objReturn.indexArr = formatLower
          .split(splitText)
          .findIndex((e) => e === "yyyy");
      }
      objReturn.isReplaceYear = true;
    }
    return objReturn;
  });

  const setFormatDate = useCallback(
    (startProps: any, endProps: any, value: any) => {
      if (locale === "th") {
        //Start
        if (value[0]) {
          if (format === "MMMM/YYYY") {
            let convertDateToString: string = moment(value[0]).format(format);
            let year = convertDateToString.split("/")[1];
            let addyear =
              parseInt(year) > 2500 ? parseInt(year) : parseInt(year) + 543;
            startProps.inputProps.value = convertDateToString.replaceAll(
              `${year}`,
              `${addyear}`
            );
          } else if (format === "YYYY") {
            let year: string = moment(value[0]).format(format);
            let addyear =
              parseInt(year) > 2500 ? parseInt(year) : parseInt(year) + 543;
            startProps.inputProps.value = addyear;
          } else {
            let convertDateToString: string = moment(value[0]).format(format);
            let year = objCheckReplace.splitText
              ? convertDateToString.split(objCheckReplace.splitText)[
              objCheckReplace.indexArr
              ]
              : convertDateToString.substring(6, 4);
            let addyear = parseInt(year) + 543;
            let replaceAllFormat = format.replaceAll("YYYY", "");
            startProps.inputProps.value =
              moment(value[0]).format(replaceAllFormat) + addyear;
          }
        }

        //End
        if (value[1]) {
          if (format === "MMMM/YYYY") {
            let convertDateToString: string = moment(value[1]).format(format);
            let year = convertDateToString.split("/")[1];
            let addyear =
              parseInt(year) > 2500 ? parseInt(year) : parseInt(year) + 543;
            endProps.inputProps.value = convertDateToString.replaceAll(
              `${year}`,
              `${addyear}`
            );
          } else if (format === "YYYY") {
            let year: string = moment(value[1]).format(format);
            let addyear =
              parseInt(year) > 2500 ? parseInt(year) : parseInt(year) + 543;
            endProps.inputProps.value = addyear;
          } else {
            let convertDateToString: string = moment(value[1]).format(format);
            let year = objCheckReplace.splitText
              ? convertDateToString.split(objCheckReplace.splitText)[
              objCheckReplace.indexArr
              ]
              : convertDateToString.substring(6, 4);
            let addyear = parseInt(year) + 543;
            let replaceAllFormat = format.replaceAll("YYYY", "");
            endProps.inputProps.value =
              moment(value[1]).format(replaceAllFormat) + addyear;
          }
        }
      }
    },
    [locale]
  );

  const rules = useMemo(() => {
    let message = `${I18n.SetText("required", I18NextNs.validation)}`
    return {
      validate: (value) => {
        if (required) {
          return (
            (value[0] != null && value[1] != null) ||
            message + ` ${label}`
          );
        }
      },
    };
  }, [required, label, SecureStorage.Get(I18n.envI18next)]);

  useMemo(() => {
    let lang = SecureStorage.Get(I18n.envI18next);
    setLocale(lang === Language.th ? "th" : "en");
  }, [SecureStorage.Get(I18n.envI18next)]);

  return (
    <Controller
      key={name}
      name={name}
      control={control}
      rules={rules}
      defaultValue={[null, null]}
      render={({
        field: { onChange, onBlur, value, ref },
        fieldState: { invalid, error },
      }) => (
        <LocalizationProvider
          adapterLocale={locale}
          dateAdapter={CustomAdapter as any}
        >
          <DateRangePicker
            value={value}
            onChange={(e) => {
              let arrValid = [null, null];
              let IsValidStart = (e[0] && moment(e[0]).isValid()) ?? false;
              if (IsValidStart) {
                arrValid[0] = e[0];
              }

              let IsValidEnd = (e[1] && moment(e[1]).isValid()) ?? false;
              if (IsValidEnd) {
                arrValid[1] = e[1];
              }

              onChange(arrValid);
              props.onChange && props.onChange(arrValid);
            }}
            components={{
              OpenPickerIcon: EventIcon,
            }}
            disabled={disabled}
            PopperProps={{
              placement: "bottom-end",
              anchorEl: anchorEl,
              // sx: {
              //   zIndex: 10,
              // },
              // style: { zIndex: 2000},
              style: { zIndex: 2000, position: IsDisablePortal ? "relative" : "absolute", },  
              // disablePortal: true,
              disablePortal: IsDisablePortal,
            }}
            showToolbar={false}
            defaultCalendarMonth={defaultCalendarMonth}
            inputFormat={format}
            minDate={minDate || null}
            maxDate={maxDate || null}
            calendars={calendarsCount}
            componentsProps={{
              actionBar: {
                actions: ["clear"],
              },
            }}
            disablePast={disablePast}
            open={open}
            onOpen={() => {
              if (!props.disabled) {
                setOpen(true);
              }
            }}
            onClose={() => setOpen(false)}
            renderInput={(startProps, endProps) => {
              setFormatDate(startProps, endProps, value);
              startProps.inputProps.placeholder = maskMap[locale];
              endProps.inputProps.placeholder = maskMap[locale];
              return (
                <>
                  <Stack
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <TextField
                      disabled={disabled}
                      size={"small"}
                      {...startProps}
                      error={invalid}
                      fullWidth
                      required={required}
                      label={labelStart}
                      autoComplete="off"
                      focused={false}
                      value={startProps.inputProps.value || ""}
                      onClick={(e) => {
                        setOpen(true);
                        setAnchorEl(e.currentTarget);
                      }}
                      helperText={
                        isShowMessageError && error ? error.message : null
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => !disabled && setOpen(true)}
                              style={{
                                marginRight: "-15px",
                              }}
                              disabled={disabled}
                            >
                              <EventIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      inputProps={{ readOnly: true }}
                      sx={{
                        "label.MuiInputLabel-shrink": {
                          top: "0px",
                        },
                        ".MuiInputLabel-outlined": {
                          top: "0px",
                        },
                      }}
                    />
                  </Stack>
                  <p
                    style={{
                      padding: "0px",
                      marginTop: "9px",
                      paddingLeft: "10px",
                      paddingRight: "10px",
                      display: "flex",
                    }}
                  >
                    <span>-</span>
                  </p>
                  <Stack
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <TextField
                      disabled={disabled}
                      size={"small"}
                      {...endProps}
                      error={invalid}
                      onClick={() => setOpen(true)}
                      required={required}
                      label={labelEnd}
                      autoComplete="off"
                      focused={false}
                      value={endProps.inputProps.value || ""}
                      fullWidth
                      inputProps={{ readOnly: true }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => !disabled && setOpen(true)}
                              style={{
                                marginRight: "-15px",
                              }}
                              disabled={disabled}
                            >
                              <EventIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        "label.MuiInputLabel-shrink": {
                          top: "0px",
                        },
                        ".MuiInputLabel-outlined": {
                          top: "0px",
                        }
                      }}
                    />
                  </Stack>
                </>
              );
            }}
          />
        </LocalizationProvider>
      )}
    />
  );
};